import { ScopeButton } from '@monorepo/shared-lib';
import { Col, GetProp, Input, Row, Typography } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeData } from 'store/account/models';

interface QRCodeSetupProps {
  QRCodeData?: QRCodeData;
  onVerifyCode: (code: string) => void;
}
const { Text } = Typography;

export const QRCodeSetup: React.FC<QRCodeSetupProps> = ({
  QRCodeData,

  onVerifyCode,
}) => {
  const { t } = useTranslation();
  const [mfaCode, setMfaCode] = React.useState<any>();
  const handleMfaChange: GetProp<typeof Input.OTP, 'onChange'> = (text) => {
    const code = text;
    if (code) {
      if (code.length <= 6 && parseInt(code, 10).toString() === code) {
        setMfaCode(code);
      } else {
      }
    } else {
      setMfaCode(undefined);
    }
  };

  const handleVerifyCode = () => {
    onVerifyCode(mfaCode ? mfaCode : '');
    setMfaCode('');
  };

  return (
    <Row justify={'center'} gutter={[0, 6]}>
      <Col span={24}>
        <Text>{t('account.mfa-setup-step-1')}</Text>
      </Col>
      <Col span={24}>
        <Text>
          {t('account.mfa-setup-step-2-before')}{' '}
          <strong>{t('account.mfa-setup-step-2-scan')}</strong>{' '}
          {t('account.mfa-setup-step-2-after')}
        </Text>
      </Col>
      <Col>
        <img src={QRCodeData?.code} width={180} height={180} />
      </Col>
      <Col span={24}>
        <Text>{t('account.mfa-setup-step-3')}</Text>
      </Col>
      <Col style={{ display: 'flex', justifyContent: 'center' }} span={24}>
        <Input
          id="code"
          maxLength={6}
          size={'large'}
          style={{
            fontSize: 17,
            letterSpacing: 7,
            width: '65%',
            marginTop: '25px',
            columnGap: '10',
            textAlign: 'center',
          }}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          onChange={(e) => handleMfaChange(e.target.value)}
          value={mfaCode}
        />
      </Col>
      <Col span={6} />
      <Col span={24}>
        <ScopeButton
          type={'primary'}
          size={'large'}
          style={{ marginTop: '25px', width: '98%' }}
          onClick={handleVerifyCode}
          disabled={!mfaCode || mfaCode.length != 6}
        >
          {t('other.verify-code')}
        </ScopeButton>
      </Col>
    </Row>
  );
};
